import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as HelpActions from 'src/app/store/help/help.actions';
import { Observable, Subscription, debounceTime, map } from 'rxjs';
import { SubSectionData } from 'src/app/model/help';
import { selectCurrentLang, selectUser } from 'src/app/store/user/user.selector';
import { Lang } from 'src/app/model/lang';
import { selectHelpSearchList } from 'src/app/store/help/help.selector';
import * as NotificationsActions from "../../../../store/notifications/notifications.actions";
import { ActivatedRoute } from '@angular/router';
import { Role } from 'src/app/model/role';
import { User } from 'src/app/model/user';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectTopbarTitle } from 'src/app/store/notifications/notifications.selector';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import { DEFAULT_LANG, LINK_CONTACT_US_DE, LINK_CONTACT_US_EN, LINK_CONTACT_US_ES, LINK_CONTACT_US_FR, LINK_CONTACT_US_IT, LINK_CONTACT_US_NL, LINK_CONTACT_US_PL } from 'src/app/conf/languages';

@Component({
	selector: 'app-helper',
	templateUrl: './helper.component.html',
})

export class HelperComponent implements OnInit, OnDestroy {
	@Input() mobile: boolean;

	currentLang$: Observable<Lang | undefined>;
	currentLangSub: Subscription | undefined;
	currentLang: Lang = DEFAULT_LANG;
	helpSearchList$: Observable<SubSectionData[] | undefined>;
	helpSearchListSub: Subscription | undefined;
	helpSearchList: SubSectionData[];

	currentUser?: User;
	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;
	currentRole?: Role;

	filterSub: Subscription;
	searchFilter: FormControl = new FormControl('');
	filter: '';

	appid: string;

	titleSel$: Observable<string>;
	titleSub: Subscription | undefined;
	titleId = '';

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private route: ActivatedRoute,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'HELPER'
		}));

		this.appid = this.route.snapshot.queryParamMap.get('appid');
		if (this.appid === null) {
			this.appid = 'frontend';
		}
		if (this.mobile === undefined) {
			this.mobile = false;
		}

		this.filter = '';
		this.filterSub = this.searchFilter.valueChanges.pipe(
			debounceTime(500),
			map(v => v.trim().toLowerCase())
		).subscribe(value => {
			this.filter = value;
			this.store.dispatch(HelpActions.getHelpSearch({ filter: this.filter, appid: this.appid }));
		}
		);
		this.subscribeAll();
		this.onResize();

		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Help' } }));
		}, 2000);
	}

	initSelectors(): void {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.helpSearchList$ = this.store.select(selectHelpSearchList);
		this.user$ = this.store.select(selectUser);
		this.titleSel$ = this.store.select(selectTopbarTitle);
	}

	subscribeAll(): void {
		this.userSub = this.user$?.subscribe(currentUser => {
			this.currentUser = currentUser;
			const roles = currentUser?.Roles;
			if (roles && roles.length > 0) {
				this.currentRole = roles[0];
			}
		});
		this.currentLangSub = this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
			if (this.filter === '') {
				this.store.dispatch(HelpActions.getHelp({ appid: this.appid }));
			} else {
				this.store.dispatch(HelpActions.getHelpSearch({ filter: this.filter, appid: this.appid }));
			}
		});
		this.helpSearchListSub = this.helpSearchList$.subscribe((helpSearchList) => {
			this.helpSearchList = helpSearchList;
		});
		this.titleSub = this.titleSel$.subscribe(
			(title: string) => {
				this.titleId = title;
			}
		);
	}

	ngOnDestroy(): void {
		this.currentLangSub?.unsubscribe();
		this.helpSearchListSub?.unsubscribe();
		this.titleSub?.unsubscribe();
	}

	accordionAction(): void {
		const listaFrames = document.getElementsByTagName('iframe');

		for (let index = 0; index <= listaFrames.length; index++) {
			if (listaFrames[index] !== undefined) {
				const iframe = listaFrames[index].contentWindow;
				iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			}
		}
	}

	openNewTabContactUs() {
		let url = LINK_CONTACT_US_EN;
		switch (this.currentLang.code) {
			case 'it-IT': {
				url = LINK_CONTACT_US_IT;
				break;
			}
			case 'es-ES': {
				url = LINK_CONTACT_US_ES;
				break;
			}
			case 'de-DE': {
				url = LINK_CONTACT_US_DE;
				break;
			}
			case 'pl-PL': {
				url = LINK_CONTACT_US_PL;
				break;
			}
			case 'nl-NL': {
				url = LINK_CONTACT_US_NL;
				break;
			}
			case 'fr-FR': {
				url = LINK_CONTACT_US_FR;
				break;
			}
			default: {
				url = LINK_CONTACT_US_EN;
				break;
			}
		}
		window.open(url, '_blank');
	}

	openNewTab(url: string) {
		window.open(url, '_blank');
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive() {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	dynamicInputTextWidth() {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-25rem');
	}

	col6HeaderPage(position: string): string {
		return StandardPageLayout.col6HeaderPage(this.screenWidth, position);
	}
}
